(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3567,3061,4892],{

/***/ 99126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ apstagBidCallback; },
/* harmony export */   "PI": function() { return /* binding */ createApsSlotsRosMobile; },
/* harmony export */   "VG": function() { return /* binding */ createApsSlotsRosDesktop; },
/* harmony export */   "WX": function() { return /* binding */ requestBiddingFromPWT; },
/* harmony export */   "Zy": function() { return /* binding */ createApsSlotsHomeMobile; },
/* harmony export */   "we": function() { return /* binding */ createApsSlotsHomeDesktop; }
/* harmony export */ });
/* unused harmony exports DEFAULT_HOME_MOBILE, createApsSlotsRosDesktopFalse, createApsSlotsRosMobileFalse */
// import { logger } from "./logging/log-util";
var requestBiddingFromPWT = function requestBiddingFromPWT() {
  console.log("AdsTest requestBiddingFromPWT"); // logger.info("requestBiddingFromPWT");

  if (typeof PWT.requestBids === "function") {
    console.log("AdsTest requestBiddingFromPWT inside if");
    PWT.requestBids(PWT.generateConfForGPT(googletag.pubads().getSlots()), function (adUnitsArray) {
      // logger.info("bids received from PWT", adUnitsArray);
      PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
      PWT.ow_BidsReceived = true;
      window.initAdserver(false);
    });
  }

  var FAILSAFE_TIMEOUT = 1000; // this timeout should > OpenWrap and TAM timeout

  setTimeout(function () {
    window.initAdserver(true); // calling this function with forced mode set to true so that GPT API is always executed
  }, FAILSAFE_TIMEOUT);
};
function apstagBidCallback(bids) {
  // logger.info("apstagBidCallback - received bids", bids);
  googletag.cmd.push(function () {
    apstag.setDisplayBids();
    PWT.TAM_BidsReceived = true;
    window.initAdserver(false);
  });
}
var DEFAULT_HOME_MOBILE = [{
  slotID: "div-gpt-ad-1657866020444-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866205249-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866282643-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866338810-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866406380-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866608917-0",
  sizes: [[320, 50]]
}];
var createApsSlotsRosDesktopFalse = function createApsSlotsRosDesktopFalse(_ref) {
  var _ref$atf = _ref.atf,
      atf = _ref$atf === void 0 ? false : _ref$atf,
      _ref$atf2 = _ref.atf300,
      atf300 = _ref$atf2 === void 0 ? false : _ref$atf2,
      _ref$mtf = _ref.mtf1,
      mtf1 = _ref$mtf === void 0 ? false : _ref$mtf,
      _ref$mtf2 = _ref.mtf2,
      mtf2 = _ref$mtf2 === void 0 ? false : _ref$mtf2,
      _ref$mtf3 = _ref.mtf3,
      mtf3 = _ref$mtf3 === void 0 ? false : _ref$mtf3,
      _ref$btf = _ref.btf,
      btf = _ref$btf === void 0 ? false : _ref$btf;
  createApsSlotsRosDesktop({
    atf: atf,
    atf300: atf300,
    mtf1: mtf1,
    mtf2: mtf2,
    mtf3: mtf3,
    btf: btf
  });
};
var createApsSlotsRosDesktop = function createApsSlotsRosDesktop(_ref2) {
  var _ref2$atf = _ref2.atf,
      atf = _ref2$atf === void 0 ? true : _ref2$atf,
      _ref2$atf2 = _ref2.atf300,
      atf300 = _ref2$atf2 === void 0 ? true : _ref2$atf2,
      _ref2$mtf = _ref2.mtf1,
      mtf1 = _ref2$mtf === void 0 ? true : _ref2$mtf,
      _ref2$mtf2 = _ref2.mtf2,
      mtf2 = _ref2$mtf2 === void 0 ? true : _ref2$mtf2,
      _ref2$mtf3 = _ref2.mtf3,
      mtf3 = _ref2$mtf3 === void 0 ? true : _ref2$mtf3,
      _ref2$btf = _ref2.btf,
      btf = _ref2$btf === void 0 ? true : _ref2$btf;
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701945163318-0",
      sizes: [[728, 90]]
    });
  }

  if (atf300) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-1",
      sizes: [[728, 90]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-2",
      sizes: [[728, 90]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-3",
      sizes: [[728, 90]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701945864013-0",
      sizes: [[728, 90]]
    });
  }

  console.log("slotss 1s", slots);
  return slots;
}; // Just a warpper with default false value

var createApsSlotsRosMobileFalse = function createApsSlotsRosMobileFalse(_ref3) {
  var _ref3$atf = _ref3.atf,
      atf = _ref3$atf === void 0 ? false : _ref3$atf,
      _ref3$mtf = _ref3.mtf1,
      mtf1 = _ref3$mtf === void 0 ? false : _ref3$mtf,
      _ref3$mtf2 = _ref3.mtf2,
      mtf2 = _ref3$mtf2 === void 0 ? false : _ref3$mtf2,
      _ref3$mtf3 = _ref3.mtf3,
      mtf3 = _ref3$mtf3 === void 0 ? false : _ref3$mtf3,
      _ref3$btf = _ref3.btf,
      btf = _ref3$btf === void 0 ? false : _ref3$btf,
      _ref3$bottom = _ref3.bottom,
      bottom = _ref3$bottom === void 0 ? false : _ref3$bottom;
  console.log("atf,mtf", atf, mtf1, mtf2, mtf3, btf, bottom);
  createApsSlotsRosMobile({
    atf: atf,
    mtf1: mtf1,
    mtf2: mtf2,
    mtf3: mtf3,
    btf: btf,
    bottom: bottom
  });
};
var createApsSlotsRosMobile = function createApsSlotsRosMobile(_ref4) {
  var _ref4$atf = _ref4.atf,
      atf = _ref4$atf === void 0 ? true : _ref4$atf,
      _ref4$mtf = _ref4.mtf1,
      mtf1 = _ref4$mtf === void 0 ? true : _ref4$mtf,
      _ref4$mtf2 = _ref4.mtf2,
      mtf2 = _ref4$mtf2 === void 0 ? true : _ref4$mtf2,
      _ref4$mtf3 = _ref4.mtf3,
      mtf3 = _ref4$mtf3 === void 0 ? true : _ref4$mtf3,
      _ref4$btf = _ref4.btf,
      btf = _ref4$btf === void 0 ? true : _ref4$btf,
      _ref4$bottom = _ref4.bottom,
      bottom = _ref4$bottom === void 0 ? true : _ref4$bottom;
  console.log("calsfdwsdf");
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-1",
      sizes: [[300, 250]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-2",
      sizes: [[300, 250]]
    });
  } // if (mtf3) {
  //   slots.push({
  //     slotID: "div-gpt-ad-1701946028239-3",
  //     sizes: [[300, 250]],
  //   });
  // }


  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-3",
      sizes: [[300, 250]]
    });
  }

  if (bottom) {
    slots.push({
      slotID: "div-gpt-ad-1701946324333-0",
      sizes: [[320, 50]]
    });
  }

  return slots;
};
var createApsSlotsHomeDesktop = function createApsSlotsHomeDesktop(_ref5) {
  var _ref5$atf = _ref5.atf,
      atf = _ref5$atf === void 0 ? true : _ref5$atf,
      _ref5$atf2 = _ref5.atf300,
      atf300 = _ref5$atf2 === void 0 ? true : _ref5$atf2,
      _ref5$mtf = _ref5.mtf1,
      mtf1 = _ref5$mtf === void 0 ? true : _ref5$mtf,
      _ref5$mtf2 = _ref5.mtf2,
      mtf2 = _ref5$mtf2 === void 0 ? true : _ref5$mtf2,
      _ref5$mtf3 = _ref5.mtf3,
      mtf3 = _ref5$mtf3 === void 0 ? true : _ref5$mtf3,
      _ref5$btf = _ref5.btf,
      btf = _ref5$btf === void 0 ? true : _ref5$btf;
  console.log("AdsTest createApsSlotsHomeDesktop");
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701945163318-0",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (atf300) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-0",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-1",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-2",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-4",
      sizes: [[728, 90], [970, 90]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-3",
      sizes: [[300, 250]]
    });
  }

  console.log("AdsTest createApsSlotsHomeDesktop slots are", slots);
  return slots;
};
var createApsSlotsHomeMobile = function createApsSlotsHomeMobile(_ref6) {
  var _ref6$atf = _ref6.atf,
      atf = _ref6$atf === void 0 ? true : _ref6$atf,
      _ref6$mtf = _ref6.mtf1,
      mtf1 = _ref6$mtf === void 0 ? true : _ref6$mtf,
      _ref6$mtf2 = _ref6.mtf2,
      mtf2 = _ref6$mtf2 === void 0 ? true : _ref6$mtf2,
      _ref6$mtf3 = _ref6.mtf3,
      mtf3 = _ref6$mtf3 === void 0 ? true : _ref6$mtf3,
      _ref6$btf = _ref6.btf,
      btf = _ref6$btf === void 0 ? true : _ref6$btf,
      _ref6$bottom = _ref6.bottom,
      bottom = _ref6$bottom === void 0 ? true : _ref6$bottom;
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-1",
      sizes: [[300, 250]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-2",
      sizes: [[300, 250]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-4",
      sizes: [[300, 250]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-3",
      sizes: [[300, 250]]
    });
  }

  if (bottom) {
    slots.push({
      slotID: "div-gpt-ad-1701946324333-0",
      sizes: [[320, 50]]
    });
  }

  return slots;
};

/***/ }),

/***/ 70014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cricket_WidgetHome; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/cricket/WidgetTable.jsx
var WidgetTable = __webpack_require__(14739);
// EXTERNAL MODULE: ./src/components/cricket/WidgetScorecard.jsx
var WidgetScorecard = __webpack_require__(72626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NewsWidget.jsx
// import { timeSince } from "constants/cardsConstant";
// import { timeSince } from "constants/cardsConstant";




var NewsWidget = function NewsWidget(_ref) {
  var _newsData$, _newsData$2;

  var newsData = _ref.newsData;

  var handleNewsClick = function handleNewsClick(item) {
    // const obj = {
    //   eventName : "News_Card_Click",
    //   pageTitle : "Home Page"
    // }
    // callGaEvent(obj)
    var type = (item === null || item === void 0 ? void 0 : item.type) == 'video' ? 'video' : 'post';
    window.location.href = "/sports/".concat(type, "/").concat(item === null || item === void 0 ? void 0 : item.postSlug);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onClick: function onClick() {
      handleNewsClick(newsData[0]);
    },
    style: {
      background: "#FFFFFF1A",
      borderRadius: "12px",
      padding: "16px",
      display: "flex",
      alignItems: "center",
      // width: "600px",
      gap: "16px",
      // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      border: "1px solid #FFFFFF4D"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        flexShrink: 0
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: (_newsData$ = newsData[0]) === null || _newsData$ === void 0 ? void 0 : _newsData$.headingImageUrl // src = ""
        ,
        alt: "Pakistan Cricket",
        style: {
          width: "120px",
          height: "80px",
          borderRadius: "8px",
          objectFit: "cover"
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        flex: 1,
        color: "white"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          margin: 0,
          fontSize: "18px",
          fontWeight: "normal"
        },
        children: (_newsData$2 = newsData[0]) === null || _newsData$2 === void 0 ? void 0 : _newsData$2.title
      })
    })]
  });
};

/* harmony default export */ var components_NewsWidget = (NewsWidget);
// EXTERNAL MODULE: ./src/constants/cricket.js
var cricket = __webpack_require__(34044);
;// CONCATENATED MODULE: ./src/components/cricket/WidgetHome.jsx









var WidgetHome = function WidgetHome(_ref) {
  var newsData = _ref.newsData,
      table = _ref.table,
      size = _ref.size,
      pointsData = _ref.pointsData,
      scoreData = _ref.scoreData,
      getStatus = _ref.getStatus;
  var IMAGE_BASE_URL = "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_c/v2/"; // useEffect(async () => {
  //   let dataFetched;
  //   const datas = await fetch(
  //     `${baseUrl}/topicItem/getContentsBySlugAndType?limit=10&skip=1&slug=champions-trophy-2025&type=text,video`
  //   );
  //   // const datas = await fetch(
  //   //   `${baseUrl}/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog`
  //   // );
  //   dataFetched = await datas?.json();
  //   dataFetched = dataFetched?.result?.entities;
  //   setElectionTopicData(dataFetched);
  // }, []);

  var _useState = (0,react.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var colors = ["green", "blue", "red", "yellow"];
  var TOTAL_ELEMENTS = 4;

  var _useState2 = (0,react.useState)(false),
      isPaused = _useState2[0],
      setIsPaused = _useState2[1];

  var touchStartX = 0;
  var touchEndX = 0; // Pause auto-slide on user interaction

  var pauseAutoSlide = function pauseAutoSlide() {
    setIsPaused(true); // setTimeout(() => setIsPaused(false), 5000); // Resume auto-slide after 5 seconds
  }; // Handle Touch Swipe (Mobile)


  var handleTouchStart = function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    pauseAutoSlide();
  };

  var handleTouchEnd = function handleTouchEnd(e) {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  };

  var handleSwipe = function handleSwipe() {
    var swipeThreshold = 50;

    if (touchStartX - touchEndX > swipeThreshold) {
      nextSlide();
    } else if (touchEndX - touchStartX > swipeThreshold) {
      prevSlide();
    }

    var obj = {
      eventName: "Hero_Widget_Scroll",
      pageTitle: "Home Page"
    };
    (0,cricket/* callGaEvent */.ut)(obj);
  }; // Go to next slide


  var nextSlide = function nextSlide() {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex + 1) % TOTAL_ELEMENTS;
    });
  }; // Go to previous slide


  var prevSlide = function prevSlide() {
    setCurrentIndex(function (prevIndex) {
      return prevIndex === 0 ? TOTAL_ELEMENTS - 1 : prevIndex - 1;
    });
  }; // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prevIndex) => (prevIndex + 1) % 3);
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, []);
  // Auto-Swipe Functionality (Pauses on Interaction)


  (0,react.useEffect)(function () {
    if (isPaused) {
      clearInterval(interval);
      return;
    } // Pause auto-slide when user interacts


    var interval = setInterval(function () {
      setCurrentIndex(function (prevIndex) {
        return (prevIndex + 1) % TOTAL_ELEMENTS;
      });
    }, 3000);
    return function () {
      return clearInterval(interval);
    };
  }, [isPaused]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: size.width ? size.width <= 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        position: "relative",
        width: "100%",
        maxWidth: "768px",
        margin: "0 auto",
        backgroundColor: "#016369",
        padding: "10px",
        backgroundImage: "url('/assets/images/bg-banner.png')",
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        style: {
          overflow: "hidden",
          borderRadius: "16px"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            display: "flex",
            transform: "translateX(-".concat(currentIndex * 100, "%)"),
            transition: "transform 0.5s ease-in-out" // backgroundColor: "#016369",

          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              var obj = {
                eventName: "Hero_Match_Card_Click",
                pageTitle: "Home Page"
              };
              (0,cricket/* callGaEvent */.ut)(obj);
            },
            style: {
              width: "100%",
              // height : "256px",
              // backgroundColor : image,
              flexShrink: "0",
              color: "white",
              padding: "10px",
              alignContent: "center" // background: "#FFFFFF1A",

            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetScorecard/* default */.Z, {
              item: scoreData,
              getStatus: getStatus,
              scoreData: scoreData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              width: "100%",
              // height : "256px",
              // backgroundColor : image,
              flexShrink: "0",
              color: "white",
              padding: "10px",
              alignContent: "center" // background: "#FFFFFF1A",

            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetTable/* default */.Z, {
              pointsData: pointsData,
              desktop: false,
              table: table,
              size: size,
              IMAGE_BASE_URL: IMAGE_BASE_URL
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              width: "100%",
              // height : "256px",
              // backgroundColor : image,
              flexShrink: "0",
              padding: "32px",
              color: "white",
              alignContent: "center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                textAlign: "center",
                flex: 1,
                margin: "0 10px",
                fontSize: "16px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
                style: {
                  margin: 0,
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  fontSize: "25px"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/assets/images/icc-icon.svg",
                  style: {
                    paddingTop: "0px"
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  style: {
                    paddingTop: "2px"
                  },
                  children: "ICC \u091A\u0948\u0902\u092A\u093F\u092F\u0902\u0938 \u091F\u094D\u0930\u0949\u092B\u0940 2025"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  marginTop: "10px"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  onClick: function onClick() {
                    var obj = {
                      eventName: "Hero_Widget_CTA_Click",
                      pageTitle: "Home Page"
                    };
                    (0,cricket/* callGaEvent */.ut)(obj);
                    window.location.href = "/topic/champions-trophy";
                  },
                  style: {
                    backgroundColor: "transparent",
                    color: "white",
                    border: "1px solid #FFFFFF4D",
                    borderRadius: "10px",
                    padding: "5px 8px",
                    cursor: "pointer"
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    "class": "custom-external-link",
                    children: "News \u2197"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  style: {
                    backgroundColor: "transparent",
                    color: "white",
                    border: "1px solid #FFFFFF4D",
                    borderRadius: "10px",
                    padding: "5px 8px",
                    cursor: "pointer"
                  },
                  onClick: function onClick() {
                    var obj = {
                      eventName: "Hero_Widget_CTA_Click",
                      pageTitle: "Home Page"
                    };
                    (0,cricket/* callGaEvent */.ut)(obj);
                    window.location.href = "/sports/cricket/champions-trophy/points-table";
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    "class": "custom-external-link",
                    children: "Points Table \u2197"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  style: {
                    backgroundColor: "transparent",
                    color: "white",
                    border: "1px solid #FFFFFF4D",
                    borderRadius: "10px",
                    padding: "5px 8px",
                    cursor: "pointer"
                  },
                  onClick: function onClick() {
                    var obj = {
                      eventName: "Hero_Widget_CTA_Click",
                      pageTitle: "Home Page"
                    };
                    (0,cricket/* callGaEvent */.ut)(obj);
                    window.location.href = "/sports/cricket/champions-trophy/schedule";
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    "class": "custom-external-link",
                    children: "Matches \u2197"
                  })
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              var obj = {
                eventName: "Hero_News_Card_Click",
                pageTitle: "Home Page"
              };
              (0,cricket/* callGaEvent */.ut)(obj);
            },
            style: {
              width: "100%",
              // height : "256px",
              // backgroundColor : image,
              flexShrink: "0",
              alignContent: "center"
            },
            children: newsData && /*#__PURE__*/(0,jsx_runtime.jsx)(components_NewsWidget, {
              newsData: newsData
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          gap: "8px"
        },
        children: colors.map(function (_, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              return setCurrentIndex(index);
            },
            style: {
              width: currentIndex === index ? "10px" : "8px",
              height: currentIndex === index ? "10px" : "8px",
              borderRadius: "50%",
              border: currentIndex === index ? "none" : "1.5px solid #d1d5db",
              transition: "background-color 1s ease",
              backgroundColor: currentIndex === index ? "#d9368b" : "transparent"
            }
          }, index);
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#016369",
        color: "white",
        padding: "20px",
        borderRadius: "10px",
        margin: "20px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        backgroundImage: "url('/assets/images/bg-banner.png')",
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: function onClick() {
          var obj = {
            eventName: "Hero_Match_Card_Click",
            pageTitle: "Home Page"
          };
          (0,cricket/* callGaEvent */.ut)(obj);
        },
        style: {
          flex: 1
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetScorecard/* default */.Z, {
          item: scoreData,
          getStatus: getStatus,
          scoreData: scoreData
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          textAlign: "center",
          flex: 1,
          margin: "0 10px",
          fontSize: "16px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
          style: {
            margin: 0,
            display: "flex",
            justifyContent: "center",
            gap: "10px"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/icc-icon.svg",
            style: {
              paddingTop: "0px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: {
              paddingTop: "2px"
            },
            children: "ICC \u091A\u0948\u0902\u092A\u093F\u092F\u0902\u0938 \u091F\u094D\u0930\u0949\u092B\u0940 2025"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "10px"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            style: {
              backgroundColor: "transparent",
              color: "white",
              border: "1px solid #FFFFFF4D",
              borderRadius: "10px",
              padding: "5px 10px",
              cursor: "pointer"
            },
            onClick: function onClick() {
              var obj = {
                eventName: "Hero_Widget_CTA_Click",
                pageTitle: "Home Page"
              };
              (0,cricket/* callGaEvent */.ut)(obj);
              window.location.href = "/topic/champions-trophy";
            },
            children: ["News ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              "class": "custom-external-link",
              children: "\u2197"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            style: {
              backgroundColor: "transparent",
              color: "white",
              border: "1px solid #FFFFFF4D",
              borderRadius: "10px",
              padding: "5px 10px",
              cursor: "pointer"
            },
            onClick: function onClick() {
              var obj = {
                eventName: "Hero_Widget_CTA_Click",
                pageTitle: "Home Page"
              };
              (0,cricket/* callGaEvent */.ut)(obj);
              window.location.href = "/sports/cricket/champions-trophy/points-table";
            },
            children: ["Points Table ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              "class": "custom-external-link",
              children: "\u2197"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            style: {
              backgroundColor: "transparent",
              color: "white",
              border: "1px solid #FFFFFF4D",
              borderRadius: "10px",
              padding: "5px 10px",
              cursor: "pointer"
            },
            onClick: function onClick() {
              var obj = {
                eventName: "Hero_Widget_CTA_Click",
                pageTitle: "Home Page"
              };
              (0,cricket/* callGaEvent */.ut)(obj);
              window.location.href = "/sports/cricket/champions-trophy/schedule";
            },
            children: ["Matches ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              "class": "custom-external-link",
              children: "\u2197"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          flex: 1
        } // style={{
        //   flex: 1,
        //   backgroundColor: "#327d7f",
        //   padding: "15px",
        //   borderRadius: "10px",
        //   marginLeft: "10px",
        // }}
        ,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetTable/* default */.Z, {
          pointsData: pointsData,
          desktop: false,
          table: table,
          size: size,
          IMAGE_BASE_URL: IMAGE_BASE_URL
        })
      })]
    }) : null
  });
};

/* harmony default export */ var cricket_WidgetHome = (WidgetHome);

/***/ }),

/***/ 74892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var FAQComponent = function FAQComponent(_ref) {
  var data = _ref.data,
      title = _ref.title,
      _ref$removeHeading = _ref.removeHeading,
      removeHeading = _ref$removeHeading === void 0 ? false : _ref$removeHeading;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var toggleAnswer = function toggleAnswer(index) {
    setActiveIndex(activeIndex === index ? null : index);
  };

  var faqs = data && data.length > 0 ? data : [];
  console.log("TITLE is ", title);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [faqs.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "faq-parent",
      children: [removeHeading === false && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
        className: "faq-title",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: "/assets/images/faq-icon.png",
          width: "24px",
          height: "24px"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          id: "FAQ"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "faq-container",
        children: faqs.map(function (faq, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "faq-item",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
              onClick: function onClick() {
                return toggleAnswer(index);
              },
              className: "faq-question",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                style: {
                  fontSize: "20px"
                },
                children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                  children: faq.question
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                  alignContent: "center",
                  cursor: "pointer"
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                  src: "/assets/images/".concat(activeIndex === index ? "minus" : "add", "-square.png"),
                  width: "24px",
                  height: "24px"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "faq-answer ".concat(activeIndex === index ? "show" : ""),
                children: faq.answer
              })
            })]
          }, index);
        })
      })]
    }), faqs.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json",
      strategy: "afterInteractive",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs === null || faqs === void 0 ? void 0 : faqs.map(function (x) {
            return {
              "@type": "Question",
              name: x.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: x.answer
              }
            };
          })
        })
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FAQComponent);

/***/ }),

/***/ 80959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ NoRecordsFoundMessage; }
/* harmony export */ });
/* unused harmony export PleaseWaitMessage */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _templateObject;






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: auto;\n  border: 5px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 5px solid #d9368b;\n  width: 50px;\n  height: 50px;\n  -webkit-animation: spin 2s linear infinite; /* Safari */\n  animation: spin 1s linear infinite;\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));
function PleaseWaitMessage(_ref) {
  var entities = _ref.entities;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: entities === null && /*#__PURE__*/_jsx(Wrapper, {})
  });
}
function NoRecordsFoundMessage(_ref2) {
  var entities = _ref2.entities;
  var customersList = entities === null ? [] : entities;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: customersList.length === 0 && entities !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      style: {
        margin: "auto"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        src: "/assets/images/no_records.jpg",
        alt: "No records"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
        style: {
          textAlign: "center"
        },
        children: "No Records Found"
      })]
    })
  });
}

/***/ }),

/***/ 84808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(27812);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(21608);
/* harmony import */ var components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2185);
/* harmony import */ var redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8969);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(44012);
/* harmony import */ var components_common_trendingToday__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51244);
/* harmony import */ var redux_actions_postAction__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25609);
/* harmony import */ var constants_cardsConstant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97208);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58533);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(9041);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20296);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(debounce__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var components_shared_loader_loader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80959);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96781);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30653);
/* harmony import */ var components_faq__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(74892);
/* harmony import */ var _Ads_index__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99126);
/* harmony import */ var components_cricket_WidgetHome__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70014);
/* harmony import */ var constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39712);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85893);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




 //import TrendingToday from "components/common/trendingToday";


 //import NotFound from "pages/404";
// import Link from "next/link";

 //import Script from "next/script";
// import Ads from "../../ad";







 // import Head from "next/head";














var ActiveTabs = function ActiveTabs(_ref) {
  var _topicData$entity, _topicData$entity2, _topicData$entity3, _topicData$entity4, _topicData$entity11, _topicData$entity12, _topicData$entity13, _topicData$entity14, _topicData$entity15, _topicData$entity16, _topicData$entity17, _topicData$entity18, _topicData$entity19, _topicData$entity20, _topicData$entity21, _topicData$entity22, _topicData$entity23, _topicData$entity24, _topicData$entity25, _topicData$entity26, _topicData$entity27, _topicData$entity28, _topicData$entity29, _topicData$entity30, _topicData$entity31, _topicData$entity32, _topicData$entity33, _topicData$entity34, _topicData$entity35, _topicData$entity36, _topicData$entity37, _topicData$entity38, _topicData$entity39, _topicData$entity40, _topicData$entity41, _ramMandirBanner$, _topicData$entity42, _topicData$entity43, _topicData$entity44, _topicData$entity45, _topicData$entity46, _topicData$entity46$t, _topicData$entity47, _topicData$entity47$v, _topicData$entity48, _topicData$entity48$a, _topicData$entity49, _topicData$entity49$s, _topicCategoryData$ac, _topicCategoryData$ac2, _topicCategoryData$ac3, _adPlacement300_600$, _adPlacement300_600$2, _topicData$entity50;

  var _ref$topicData = _ref.topicData,
      topicData = _ref$topicData === void 0 ? {} : _ref$topicData,
      _ref$topicName = _ref.topicName,
      topicName = _ref$topicName === void 0 ? "" : _ref$topicName,
      ramMandirBanner = _ref.ramMandirBanner,
      pointsData = _ref.pointsData,
      scoreData = _ref.scoreData,
      cricketData = _ref.cricketData;
  console.log("ramMandirBanner", topicData); //const [recordPerPage, setRecordPerPage] = useState(5);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var query = router.query;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
  var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(query.activeTab || "text"),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var masterConfig = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_18__/* .MasterConfigContext */ .d); // const [hashtagsByType, getHashtagsByType] = useState("text");

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    text: true,
    video: true,
    audio: true,
    shorts: true
  }),
      hasMore = _useState2[0],
      setHasMore = _useState2[1]; // const [skipPerPage, setSkipPerPage] = useState({
  //   text: 5,
  //   video: 5,
  //   audio: 5,
  //   shorts: 5,
  // });


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    text: 2,
    video: 2,
    audio: 2,
    shorts: 2
  }),
      skipPerPage = _useState3[0],
      setSkipPerPage = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    text: (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity = topicData.entity) === null || _topicData$entity === void 0 ? void 0 : _topicData$entity.textArticles) || [],
    video: (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity2 = topicData.entity) === null || _topicData$entity2 === void 0 ? void 0 : _topicData$entity2.videoArticles) || [],
    audio: (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity3 = topicData.entity) === null || _topicData$entity3 === void 0 ? void 0 : _topicData$entity3.audioArticles) || [],
    shorts: (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity4 = topicData.entity) === null || _topicData$entity4 === void 0 ? void 0 : _topicData$entity4.shortsArticles) || []
  }),
      topicCategoryData = _useState4[0],
      setTopicCategoryData = _useState4[1];

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_13__/* .useWindowSize */ .iP)();

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(90),
      threshold = _useState5[0],
      setThreshold = _useState5[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if ((size === null || size === void 0 ? void 0 : size.width) < 400) {
      setThreshold(4);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 460) {
      setThreshold(4);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 500) {
      setThreshold(4);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 550) {
      setThreshold(4);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 600) {
      setThreshold(3);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 800) {
      setThreshold(3);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 1000) {
      setThreshold(3);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 1200) {
      setThreshold(3);
    } else if ((size === null || size === void 0 ? void 0 : size.width) < 1450) {
      setThreshold(3);
    } else {
      setThreshold(3);
    }
  }, [size]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var _topicData$entity5, _topicData$entity5$te, _topicData$entity6, _topicData$entity6$vi, _topicData$entity7, _topicData$entity7$au, _topicData$entity8, _topicData$entity8$sh;

    if (topicData !== null && topicData !== void 0 && (_topicData$entity5 = topicData.entity) !== null && _topicData$entity5 !== void 0 && (_topicData$entity5$te = _topicData$entity5.textArticles) !== null && _topicData$entity5$te !== void 0 && _topicData$entity5$te.length) {
      setActiveTab("text");
    } else if (topicData !== null && topicData !== void 0 && (_topicData$entity6 = topicData.entity) !== null && _topicData$entity6 !== void 0 && (_topicData$entity6$vi = _topicData$entity6.videoArticles) !== null && _topicData$entity6$vi !== void 0 && _topicData$entity6$vi.length) {
      setActiveTab("video");
    } else if (topicData !== null && topicData !== void 0 && (_topicData$entity7 = topicData.entity) !== null && _topicData$entity7 !== void 0 && (_topicData$entity7$au = _topicData$entity7.audioArticles) !== null && _topicData$entity7$au !== void 0 && _topicData$entity7$au.length) {
      setActiveTab("audio");
    } else if (topicData !== null && topicData !== void 0 && (_topicData$entity8 = topicData.entity) !== null && _topicData$entity8 !== void 0 && (_topicData$entity8$sh = _topicData$entity8.shortsArticles) !== null && _topicData$entity8$sh !== void 0 && _topicData$entity8$sh.length) {
      setActiveTab("shorts");
    }
  }, []);

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isClamped = _useState6[0],
      setClamped = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isExpanded = _useState7[0],
      setExpanded = _useState7[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setTimeout(function () {
      if (contentRef && contentRef.current) {
        setClamped(contentRef.current.scrollHeight > contentRef.current.clientHeight);
      }
    }, 300);
  }, []);

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (_ref2) {
    var AdsReducer = _ref2.AdsReducer;
    return AdsReducer;
  }),
      adPlacement300_600 = _useSelector.adPlacement300_600; // const tabName = router.asPath.split("/")[1];


  var _useSelector2 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (_ref3) {
    var PostReducer = _ref3.PostReducer;
    return PostReducer;
  }),
      trendingPosts = _useSelector2.trendingPosts;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    dispatch((0,redux_actions_postAction__WEBPACK_IMPORTED_MODULE_20__/* .getTrendingPosts */ .E7)());
  }, [dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    dispatch((0,redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_21__/* .getAdsBySize */ .R)());
  }, [dispatch]);
  var getMorePost = (0,debounce__WEBPACK_IMPORTED_MODULE_9__.debounce)( /*#__PURE__*/(0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _topicData$entity9, _newPosts$result, _newPosts$result$enti;

    var res, newPosts, _newPosts$result2;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_23__/* .baseUrl */ .FH, "/topicItem/getContentsBySlugAndType?limit=", 5, "&skip=").concat(skipPerPage[activeTab] || 0, "&slug=").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity9 = topicData.entity) === null || _topicData$entity9 === void 0 ? void 0 : _topicData$entity9.slug, "&type=").concat(activeTab), {
              method: "GET",
              headers: {
                "content-type": "application/json"
              }
            });

          case 2:
            res = _context.sent;
            _context.next = 5;
            return res.json();

          case 5:
            newPosts = _context.sent;

            if ((newPosts === null || newPosts === void 0 ? void 0 : (_newPosts$result = newPosts.result) === null || _newPosts$result === void 0 ? void 0 : (_newPosts$result$enti = _newPosts$result.entities) === null || _newPosts$result$enti === void 0 ? void 0 : _newPosts$result$enti.length) > 0) {
              setTopicCategoryData(_objectSpread(_objectSpread({}, topicCategoryData), {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, activeTab, [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(topicCategoryData[activeTab]), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(newPosts === null || newPosts === void 0 ? void 0 : (_newPosts$result2 = newPosts.result) === null || _newPosts$result2 === void 0 ? void 0 : _newPosts$result2.entities)))));
            } else {
              setHasMore(_objectSpread(_objectSpread({}, hasMore), {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, activeTab, false)));
            } // setSkipPerPage({ ...skipPerPage, [activeTab]: skipPerPage["text"] + 10 });


            setSkipPerPage(_objectSpread(_objectSpread({}, skipPerPage), {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, activeTab, skipPerPage[activeTab] + 1))); // } else setLoginPrompt(true);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 1000);

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      firstScroll = _useState8[0],
      setFirstScroll = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      adCalled = _useState9[0],
      setAdCalled = _useState9[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var showAds = true;

    if (false) {}

    if (showAds && !adCalled) {
      setAdCalled(true);
      setTimeout(function () {
        window.googletag = window.googletag || {
          cmd: []
        };

        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_16__/* .requestBiddingFromPWT */ .WX)();
          });
        } else {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_16__/* .requestBiddingFromPWT */ .WX)();
          });
        } // apstag.fetchBids(
        //   {
        //     slots:
        //       size?.width < 499
        //         ? createApsSlotsRosMobile({})
        //         : createApsSlotsRosDesktop({}),
        //     timeout: 2e3,
        //   },
        //   apstagBidCallback
        // );

      }, 500);
    }
  }, [firstScroll]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (size.width) {
      apstag.fetchBids({
        slots: size.width < 768 ? (0,_Ads_index__WEBPACK_IMPORTED_MODULE_16__/* .createApsSlotsRosMobile */ .PI)({}) : (0,_Ads_index__WEBPACK_IMPORTED_MODULE_16__/* .createApsSlotsRosDesktop */ .VG)({}),
        timeout: 2e3
      }, _Ads_index__WEBPACK_IMPORTED_MODULE_16__/* .apstagBidCallback */ .O8);
    }
  }, [size.width]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    function onFirstScroll() {
      return _onFirstScroll.apply(this, arguments);
    }

    function _onFirstScroll() {
      _onFirstScroll = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!firstScroll) {
                  setFirstScroll(true);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onFirstScroll.apply(this, arguments);
    }

    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);
  var parseHtml = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    var _topicData$entity10;

    return (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_7__/* .removeHtmlTags */ .IQ)(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity10 = topicData.entity) === null || _topicData$entity10 === void 0 ? void 0 : _topicData$entity10.articleHTML);
  }, [topicData === null || topicData === void 0 ? void 0 : (_topicData$entity11 = topicData.entity) === null || _topicData$entity11 === void 0 ? void 0 : _topicData$entity11.articleHTML]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_12___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "keywords",
        content: "".concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity12 = topicData.entity) === null || _topicData$entity12 === void 0 ? void 0 : _topicData$entity12.metaKeywords, " ")
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "author",
        content: "TheLallantop"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        property: "fb:pages",
        content: "1453842511589254"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        property: "article:modified_time",
        content: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity13 = topicData.entity) === null || _topicData$entity13 === void 0 ? void 0 : _topicData$entity13.updatedAt
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        property: "article:published_time",
        content: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity14 = topicData.entity) === null || _topicData$entity14 === void 0 ? void 0 : _topicData$entity14.publishedAt
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "twitter:title",
        content: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity15 = topicData.entity) === null || _topicData$entity15 === void 0 ? void 0 : _topicData$entity15.englishTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "twitter:image",
        content: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity16 = topicData.entity) === null || _topicData$entity16 === void 0 ? void 0 : _topicData$entity16.headingImageUrl
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "twitter:site_name",
        content: "The Lallantop"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "twitter:description",
        content: parseHtml && parseHtml.length > 150 ? parseHtml.slice(0, 150) : parseHtml
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("meta", {
        name: "twitter:url",
        content: "".concat("https://www.thelallantop.com/", "topic/").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity17 = topicData.entity) === null || _topicData$entity17 === void 0 ? void 0 : _topicData$entity17.slug)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "WebPage",
            name: "".concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity18 = topicData.entity) === null || _topicData$entity18 === void 0 ? void 0 : _topicData$entity18.englishTitle) || topicName, " Latest News, Updates in Hindi | ").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity19 = topicData.entity) === null || _topicData$entity19 === void 0 ? void 0 : _topicData$entity19.title, " \u0915\u0947 \u0938\u092E\u093E\u091A\u093E\u0930 \u0914\u0930 \u0905\u092A\u0921\u0947\u091F - The Lallantop"),
            description: "".concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity20 = topicData.entity) === null || _topicData$entity20 === void 0 ? void 0 : _topicData$entity20.englishTitle) || topicName, " News in Hindi: Get More information on ").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity21 = topicData.entity) === null || _topicData$entity21 === void 0 ? void 0 : _topicData$entity21.title, " including breaking news, speech, opinion and analysis. Check News articles, photos, videos of ").concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity22 = topicData.entity) === null || _topicData$entity22 === void 0 ? void 0 : _topicData$entity22.englishTitle) || topicName, " at The Lallantop"),
            url: "".concat("https://www.thelallantop.com/", "topic/").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity23 = topicData.entity) === null || _topicData$entity23 === void 0 ? void 0 : _topicData$entity23.slug),
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                width: 600,
                height: 60
              }
            }
          })
        }
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_11__/* .NextSeo */ .PB, {
      canonical: "".concat("https://www.thelallantop.com/", "topic/").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity24 = topicData.entity) === null || _topicData$entity24 === void 0 ? void 0 : _topicData$entity24.slug),
      title: "".concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity25 = topicData.entity) === null || _topicData$entity25 === void 0 ? void 0 : _topicData$entity25.metaTitle, " "),
      description: "".concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity26 = topicData.entity) === null || _topicData$entity26 === void 0 ? void 0 : _topicData$entity26.metaDescription, " "),
      datePublished: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity27 = topicData.entity) === null || _topicData$entity27 === void 0 ? void 0 : _topicData$entity27.publishedAt,
      dateModified: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity28 = topicData.entity) === null || _topicData$entity28 === void 0 ? void 0 : _topicData$entity28.updatedAt,
      openGraph: {
        url: "".concat("https://www.thelallantop.com/", "topic/").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity29 = topicData.entity) === null || _topicData$entity29 === void 0 ? void 0 : _topicData$entity29.slug),
        title: "".concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity30 = topicData.entity) === null || _topicData$entity30 === void 0 ? void 0 : _topicData$entity30.englishTitle) || topicName, " Latest News, Updates in Hindi | ").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity31 = topicData.entity) === null || _topicData$entity31 === void 0 ? void 0 : _topicData$entity31.title, " \u0915\u0947 \u0938\u092E\u093E\u091A\u093E\u0930 \u0914\u0930 \u0905\u092A\u0921\u0947\u091F - The Lallantop"),
        description: "".concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity32 = topicData.entity) === null || _topicData$entity32 === void 0 ? void 0 : _topicData$entity32.englishTitle) || topicName, " News in Hindi: Get More information on ").concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity33 = topicData.entity) === null || _topicData$entity33 === void 0 ? void 0 : _topicData$entity33.title, " including breaking news, speech, opinion and analysis. Check News articles, photos, videos of ").concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity34 = topicData.entity) === null || _topicData$entity34 === void 0 ? void 0 : _topicData$entity34.englishTitle) || topicName, " at The Lallantop"),
        type: "website",
        images: [{
          url: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity35 = topicData.entity) === null || _topicData$entity35 === void 0 ? void 0 : _topicData$entity35.headingImageUrl,
          alt: "".concat((topicData === null || topicData === void 0 ? void 0 : (_topicData$entity36 = topicData.entity) === null || _topicData$entity36 === void 0 ? void 0 : _topicData$entity36.englishTitle) || (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity37 = topicData.entity) === null || _topicData$entity37 === void 0 ? void 0 : _topicData$entity37.title), " - thumbnail image")
        }],
        site_name: "The Lallantop"
      },
      twitter: {
        handle: "@TheLallantop",
        site: "@TheLallantop",
        cardType: "summary_large_image"
      },
      facebook: {
        appId: "574628820637757"
      },
      robotsProps: {
        // maxSnippet: -1,
        maxImagePreview: "large" // maxVideoPreview: -1,

      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("h1", {
      className: "h1Hide",
      children: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity38 = topicData.entity) === null || _topicData$entity38 === void 0 ? void 0 : _topicData$entity38.englishTitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
      className: "content-wrapper",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
        align: "center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
            id: size.width > 600 ? "div-gpt-ad-1701945163318-0" : "div-gpt-ad-1701946028239-0",
            style: {
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
              }
            })
          })]
        })
      }), masterConfig['ChampionsTrophyWidget']['MainBanners'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(components_cricket_WidgetHome__WEBPACK_IMPORTED_MODULE_17__["default"], {
        newsData: cricketData,
        scoreData: scoreData,
        pointsData: pointsData,
        table: pointsData.standings.stage1.groups[0],
        size: size
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("ul", {
          className: "breadcrumb",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
              href: "/",
              passHref: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("a", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("i", {
                  className: "icon-cat-home"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("span", {
                  children: "Home"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
              href: "/topic",
              passHref: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("span", {
                  children: "Topics"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
              href: "/topic/".concat(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity39 = topicData.entity) === null || _topicData$entity39 === void 0 ? void 0 : _topicData$entity39.slug),
              passHref: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("span", {
                  children: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity40 = topicData.entity) === null || _topicData$entity40 === void 0 ? void 0 : _topicData$entity40.englishTitle
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
          className: "container-row",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
            className: "card-wrapper",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
              className: "card-left",
              children: [(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity41 = topicData.entity) === null || _topicData$entity41 === void 0 ? void 0 : _topicData$entity41.title) === "राम मंदिर" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                className: "topic-custom-container ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                  src: (_ramMandirBanner$ = ramMandirBanner[0]) === null || _ramMandirBanner$ === void 0 ? void 0 : _ramMandirBanner$.bannerImage,
                  width: "100%",
                  height: "auto",
                  alt: "person" // style={{
                  //   minHeight: "80px",
                  //   maxHeight: "400px",
                  //   aspectRatio: "1/1",
                  // }}
                  // className="rounded-4"

                })
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                className: "card-body columnist-detail-head mb-3 text-white",
                style: {
                  borderRadius: "1.5rem !important",
                  padding: "2rem !important",
                  margin: "0.5rem",
                  backgroundColor: "#016369"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                  className: "float-start",
                  style: {
                    // width: "40%",
                    marginRight: "2rem"
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                    src: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity42 = topicData.entity) === null || _topicData$entity42 === void 0 ? void 0 : _topicData$entity42.headingImageUrl,
                    width: "122px",
                    height: "122px",
                    alt: "person",
                    style: {
                      minHeight: "80px",
                      maxHeight: "400px",
                      aspectRatio: "1/1"
                    },
                    className: "rounded-4"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("h4", {
                  className: "position-relative mb-0 topic-title",
                  children: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity43 = topicData.entity) === null || _topicData$entity43 === void 0 ? void 0 : _topicData$entity43.title
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("p", {
                  className: "m-0",
                  children: [(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity44 = topicData.entity) === null || _topicData$entity44 === void 0 ? void 0 : _topicData$entity44.articleHTML) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("span", {
                    style: {
                      textAlign: "justify",
                      WebkitLineClamp: isExpanded ? null : threshold
                    },
                    ref: contentRef,
                    className: isExpanded ? "" : "topic-card-clamp",
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity45 = topicData.entity) === null || _topicData$entity45 === void 0 ? void 0 : _topicData$entity45.articleHTML)
                  }), isClamped && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("span", {
                    className: "d-flex align-items-center",
                    type: "button",
                    onClick: function onClick() {
                      return setExpanded(!isExpanded);
                    },
                    style: {
                      height: 30,
                      justifyContent: isExpanded ? "center" : "flex-end"
                    },
                    children: isExpanded ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("span", {
                      className: "topic_read_more",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        id: "read_less",
                        defaultMessage: "\u0915\u092E \u092A\u0922\u093C\u0947\u0902"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                        src: "/assets/images/icons8-chevron-up-48.png",
                        width: 18,
                        height: 18,
                        style: {
                          marginLeft: 5
                        },
                        alt: "read less"
                      })]
                    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("span", {
                      className: "topic_read_more",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        id: "read_more",
                        defaultMessage: "\u0914\u0930 \u092A\u0922\u093C\u0947\u0902"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                        src: "/assets/images/icons8-down-arrow-48.png",
                        width: 18,
                        height: 18,
                        style: {
                          marginLeft: 5
                        },
                        alt: "read more"
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                className: "card-body mb-4",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                  className: "topic-container",
                  children: [(topicData === null || topicData === void 0 ? void 0 : (_topicData$entity46 = topicData.entity) === null || _topicData$entity46 === void 0 ? void 0 : (_topicData$entity46$t = _topicData$entity46.textArticles) === null || _topicData$entity46$t === void 0 ? void 0 : _topicData$entity46$t.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                    className: "topic-tab-list ".concat(activeTab === "text" ? "active" : "inactive"),
                    onClick: function onClick() {
                      return setActiveTab("text");
                    },
                    children: "Articles"
                  }), (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity47 = topicData.entity) === null || _topicData$entity47 === void 0 ? void 0 : (_topicData$entity47$v = _topicData$entity47.videoArticles) === null || _topicData$entity47$v === void 0 ? void 0 : _topicData$entity47$v.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                    className: "topic-tab-list ".concat(activeTab === "video" ? "active" : "inactive"),
                    onClick: function onClick() {
                      return setActiveTab("video");
                    },
                    children: "Videos"
                  }), (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity48 = topicData.entity) === null || _topicData$entity48 === void 0 ? void 0 : (_topicData$entity48$a = _topicData$entity48.audioArticles) === null || _topicData$entity48$a === void 0 ? void 0 : _topicData$entity48$a.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                    className: "topic-tab-list ".concat(activeTab === "audio" ? "active" : "inactive"),
                    onClick: function onClick() {
                      return setActiveTab("audio");
                    },
                    children: "Audio"
                  }), (topicData === null || topicData === void 0 ? void 0 : (_topicData$entity49 = topicData.entity) === null || _topicData$entity49 === void 0 ? void 0 : (_topicData$entity49$s = _topicData$entity49.shortsArticles) === null || _topicData$entity49$s === void 0 ? void 0 : _topicData$entity49$s.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                    className: "topic-tab-list ".concat(activeTab === "shorts" ? "active" : "inactive"),
                    onClick: function onClick() {
                      return setActiveTab("shorts");
                    },
                    children: "Shorts"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      dataLength: topicCategoryData[activeTab].length,
                      next: getMorePost,
                      hasMore: hasMore[activeTab],
                      loader: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                        className: "lds-dual-ring"
                      }) // style={{ marginLeft: "-10px" }}
                      ,
                      scrollThreshold: 0.5,
                      children: [console.log("activeTab", activeTab, activeTab === "shorts"), activeTab === "shorts" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                        className: "d-flex flex-wrap flex-row gap-2 custom-shorts-container",
                        children: (_topicCategoryData$ac = topicCategoryData[activeTab]) === null || _topicCategoryData$ac === void 0 ? void 0 : _topicCategoryData$ac.map(function (postData) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
                              className: "cursor-pointer",
                              href: postData === null || postData === void 0 ? void 0 : postData.permalink,
                              children: postData && (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                                  src: (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=200",
                                  alt: (postData === null || postData === void 0 ? void 0 : postData.imgAltText) || "News pic"
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                                  className: "news-type-icon",
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("i", {
                                    style: {
                                      color: "white"
                                    },
                                    className: "icon-play-circle"
                                  })
                                })]
                              })
                            })
                          }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                        })
                      }) : activeTab === "audio" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                        className: "row-cols-1",
                        children: (_topicCategoryData$ac2 = topicCategoryData[activeTab]) === null || _topicCategoryData$ac2 === void 0 ? void 0 : _topicCategoryData$ac2.map(function (postData, index) {
                          var _postData$permalink;

                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                            children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("a", {
                              className: "outer-container-audio",
                              href: postData === null || postData === void 0 ? void 0 : (_postData$permalink = postData.permalink) === null || _postData$permalink === void 0 ? void 0 : _postData$permalink.split(".com")[1],
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                                className: "img-cont",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                                  src: (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=200",
                                  layout: "fill",
                                  alt: (postData === null || postData === void 0 ? void 0 : postData.imgAltText) || "News pic"
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                                  className: "news-type-icon",
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("i", {
                                    className: "icon-mic"
                                  })
                                })]
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                                className: "right-side",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                                  className: "title",
                                  children: postData === null || postData === void 0 ? void 0 : postData.title
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                                  style: {
                                    color: "gray",
                                    marginBottom: "2px"
                                  },
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("span", {
                                    className: "pre-span",
                                    style: {
                                      marginRight: "100px"
                                    },
                                    children: [postData !== null && postData !== void 0 && postData.publishedAt ? (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_7__/* .timeSince */ .VG)(postData === null || postData === void 0 ? void 0 : postData.publishedAt) : (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_7__/* .timeSince */ .VG)(postData === null || postData === void 0 ? void 0 : postData.createdAt), " ", "ago"]
                                  })
                                })]
                              })]
                            })]
                          }, index);
                        })
                      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                        className: "row-cols-1",
                        children: (_topicCategoryData$ac3 = topicCategoryData[activeTab]) === null || _topicCategoryData$ac3 === void 0 ? void 0 : _topicCategoryData$ac3.map(function (postData) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            postData: postData,
                            isTopic: true
                          }, postData === null || postData === void 0 ? void 0 : postData._id);
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(components_shared_loader_loader__WEBPACK_IMPORTED_MODULE_10__/* .NoRecordsFoundMessage */ .j, {
                      entities: topicCategoryData[activeTab]
                    })]
                  })
                })]
              })]
            }), adPlacement300_600.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
              className: "card-right",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                className: "sponser-card no-bg s-970x250",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
                  href: adPlacement300_600 && ((_adPlacement300_600$ = adPlacement300_600[0]) === null || _adPlacement300_600$ === void 0 ? void 0 : _adPlacement300_600$.redirect_url) || "#",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("img", {
                    src: adPlacement300_600 && ((_adPlacement300_600$2 = adPlacement300_600[0]) === null || _adPlacement300_600$2 === void 0 ? void 0 : _adPlacement300_600$2.image_url),
                    alt: "ads"
                  })
                })
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
              className: "card-right",
              children: !!(trendingPosts !== null && trendingPosts !== void 0 && trendingPosts.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(components_common_trendingToday__WEBPACK_IMPORTED_MODULE_6__["default"], {
                data: trendingPosts
              })
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(components_faq__WEBPACK_IMPORTED_MODULE_15__["default"], {
      data: topicData === null || topicData === void 0 ? void 0 : (_topicData$entity50 = topicData.entity) === null || _topicData$entity50 === void 0 ? void 0 : _topicData$entity50.faqs
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ActiveTabs);

/***/ }),

/***/ 97208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IQ": function() { return /* binding */ removeHtmlTags; },
/* harmony export */   "OK": function() { return /* binding */ adsPositioning; },
/* harmony export */   "Pj": function() { return /* binding */ formatDateIST; },
/* harmony export */   "VG": function() { return /* binding */ timeSince; },
/* harmony export */   "WJ": function() { return /* binding */ divideArrayIntoColumns; },
/* harmony export */   "ZY": function() { return /* binding */ getMonthName; },
/* harmony export */   "ac": function() { return /* binding */ formatDateISTCricket; },
/* harmony export */   "er": function() { return /* binding */ adsDiv; },
/* harmony export */   "kg": function() { return /* binding */ formatDateEnglishOnly; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "q3": function() { return /* binding */ removeEmbeds; },
/* harmony export */   "t4": function() { return /* binding */ myCustomSplit; }
/* harmony export */ });
/* unused harmony exports msToTime, formatDateDefault, isoStringWithOffset, shimmer, toBase64 */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var timeSince = function timeSince(date) {
  var seconds = Math.floor((new Date() - new Date(date)) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    var toReturn = Math.floor(interval);
    return "".concat(toReturn, " ").concat(toReturn === 1 ? "year" : "years");
  }

  interval = seconds / 2592000;

  if (interval > 1) {
    var _toReturn = Math.floor(interval);

    return "".concat(_toReturn, " ").concat(_toReturn === 1 ? "month" : "months");
  }

  interval = seconds / 86400;

  if (interval > 1) {
    var _toReturn2 = Math.floor(interval);

    return "".concat(_toReturn2, " ").concat(_toReturn2 === 1 ? "day" : "days");
  }

  interval = seconds / 3600;

  if (interval > 1) {
    var _toReturn3 = Math.floor(interval);

    return "".concat(_toReturn3, " ").concat(_toReturn3 === 1 ? "hour" : "hours");
  }

  interval = seconds / 60;

  if (interval > 1) {
    var _toReturn4 = Math.floor(interval);

    return "".concat(_toReturn4, " ").concat(_toReturn4 === 1 ? "minute" : "minutes");
  }

  var finalSeconds = Math.floor(seconds);
  return (finalSeconds >= 0 ? finalSeconds : 0) + " seconds";
};
var msToTime = function msToTime(duration) {
  var milliseconds = parseInt(duration % 1000 / 100),
      seconds = Math.floor(duration / 1000 % 60),
      minutes = Math.floor(duration / (1000 * 60) % 60),
      hours = Math.floor(duration / (1000 * 60 * 60) % 24);
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  if (hours > 0) return hours + ":" + minutes + ":" + seconds;
  return minutes + ":" + seconds;
};
var formatDate = function formatDate(dateString) {
  var dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  var timeOptions = {
    hour: "2-digit",
    minute: "2-digit"
  };
  return {
    date: new Date(dateString).toLocaleDateString("hi-IN", dateOptions),
    time: new Date(dateString).toLocaleTimeString("en-US", timeOptions)
  };
};
var formatDateEnglishOnly = function formatDateEnglishOnly(dateString) {
  var dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  var timeOptions = {
    hour: "2-digit",
    minute: "2-digit"
  };
  return {
    date: new Date(dateString).toLocaleDateString("en-US", dateOptions),
    time: new Date(dateString).toLocaleTimeString("en-US", timeOptions)
  };
};
var formatDateIST = function formatDateIST(dateString) {
  var dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  var timeOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  };
  return {
    date: new Date(dateString).toLocaleDateString("hi-IN", dateOptions),
    time: new Date(dateString).toLocaleString("en-US", timeOptions)
  };
};
var formatDateISTCricket = function formatDateISTCricket(dateString) {
  var date = new Date(dateString);
  date.setHours(date.getHours() + 5);
  date.setMinutes(date.getMinutes() + 30);
  var dateOptions = {
    weekday: "short",
    month: "short",
    day: "numeric"
  };
  var timeOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  };
  return {
    date: new Date(date).toLocaleDateString("en-US", dateOptions),
    time: new Date(date).toLocaleString("en-US", timeOptions)
  };
};
var formatDateDefault = function formatDateDefault(date) {
  date.setHours(date.getHours() + 5);
  date.setMinutes(date.getMinutes() + 30);
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  if (hour > 12) {
    hour = hour - 12;
  }

  if (hour == 0) {
    hour = 12;
  }

  if (hour < 10) {
    hour = "0" + hour;
  }

  if (minute < 10) {
    minute = "0" + minute;
  }

  if (second < 10) {
    second = "0" + second;
  }

  var timeString = hour + ":" + minute + ":" + second + " ";
  return date.toISOString().substring(0, 10) + " ".concat(timeString);
};
var getMonthName = function getMonthName(date) {
  var _monthNames$date$getM;

  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return (_monthNames$date$getM = monthNames[date.getMonth()]) === null || _monthNames$date$getM === void 0 ? void 0 : _monthNames$date$getM.slice(0, 3);
};
var isoStringWithOffset = function isoStringWithOffset(date) {
  date = new Date(date);

  var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? "+" : "-",
      pad = function pad(num) {
    return (num < 10 ? "0" : "") + num;
  };

  return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + "T" + pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds()) + dif + pad(Math.floor(Math.abs(tzo) / 60)) + ":" + pad(Math.abs(tzo) % 60);
};
var shimmer = function shimmer(w, h) {
  return "\n<svg width=\"".concat(w, "\" height=\"").concat(h, "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <defs>\n    <linearGradient id=\"g\">\n      <stop stop-color=\"#333\" offset=\"20%\" />\n      <stop stop-color=\"#222\" offset=\"50%\" />\n      <stop stop-color=\"#333\" offset=\"70%\" />\n    </linearGradient>\n  </defs>\n  <rect width=\"").concat(w, "\" height=\"").concat(h, "\" fill=\"#333\" />\n  <rect id=\"r\" width=\"").concat(w, "\" height=\"").concat(h, "\" fill=\"url(#g)\" />\n  <animate xlink:href=\"#r\" attributeName=\"x\" from=\"-").concat(w, "\" to=\"").concat(w, "\" dur=\"1s\" repeatCount=\"indefinite\"  />\n</svg>");
};
var toBase64 = function toBase64(str) {
  return  false ? 0 : window.btoa(str);
};
var myCustomSplit = function myCustomSplit(str) {
  var _outputArr;

  var outputArr = [];
  outputArr = str === null || str === void 0 ? void 0 : str.split("</p>");
  (_outputArr = outputArr) === null || _outputArr === void 0 ? void 0 : _outputArr.map(function (data, index) {
    outputArr[index] = outputArr[index] + "</p>";
  });
  var totalo = 0; //Total opening blockquote tags

  var totalc = 0; // Total closing blockquote tags

  for (var x = 0; x < ((_outputArr2 = outputArr) === null || _outputArr2 === void 0 ? void 0 : _outputArr2.length); x++) {
    var _outputArr2, _outputArr$x, _outputArr$x2;

    var opening = ((_outputArr$x = outputArr[x]) === null || _outputArr$x === void 0 ? void 0 : _outputArr$x.split("<blockquote").length) - 1;
    /*  Counts how many opening and closing blockquote tags
        are there on the current position of the array  */

    var closing = ((_outputArr$x2 = outputArr[x]) === null || _outputArr$x2 === void 0 ? void 0 : _outputArr$x2.split("</blockquote>").length) - 1;
    totalo = opening;
    totalc = closing;

    if (closing !== opening) {
      var ind = x;
      /*Keep merging all the indexes ahead to outputArr[ind] 
           till the time we achieve closing===opening */

      while (true) {
        var _outputArr$x3, _outputArr$x4;

        x++;
        outputArr[ind] = outputArr[ind] + outputArr[x];
        var openingInternal = ((_outputArr$x3 = outputArr[x]) === null || _outputArr$x3 === void 0 ? void 0 : _outputArr$x3.split("<blockquote").length) - 1;
        var closingInternal = ((_outputArr$x4 = outputArr[x]) === null || _outputArr$x4 === void 0 ? void 0 : _outputArr$x4.split("</blockquote>").length) - 1;
        outputArr[x] = "";
        totalo = totalo + openingInternal;
        totalc = totalc + closingInternal;

        if (totalo === totalc) {
          totalo = 0;
          totalc = 0;
          break;
        }
      }
    }
  }

  var finalArray = [];

  for (var _x = 0; _x < ((_outputArr3 = outputArr) === null || _outputArr3 === void 0 ? void 0 : _outputArr3.length); _x++) {
    var _outputArr3, _outputArr$_x;

    //Remove all indexes whose length have become 0
    if (((_outputArr$_x = outputArr[_x]) === null || _outputArr$_x === void 0 ? void 0 : _outputArr$_x.length) !== 0) {
      finalArray.push(outputArr[_x]);
    }
  }

  return finalArray;
};
/*Splits the html content by p tag, If we find a
       blockquote tag opening and  and it's respective closing tag in some other
       index below , we will merge all the indexes in between
       to a single index till the opening and closing tag of that blockquote doesnt
       come in 1 index */
// Current Ad logic-
// After 1st,4th

var adsPositioning = function adsPositioning(splitedArray) {
  splitedArray.map(function (article, index) {
    var opening = article.split("<p>").length - 1;
    var closing = article.split("</p>").length - 1;

    if (opening !== closing) {
      splitedArray[index] = splitedArray[index] + "</p>";
    }
  });
  var ar = [];
  ar[0] = splitedArray[0];
  ar[1] = splitedArray[1] !== undefined ? splitedArray[1] : "";
  ar[2] = (splitedArray[2] !== undefined ? splitedArray[2] : "") + (splitedArray[3] !== undefined ? splitedArray[3] : "");
  ar[3] = "";

  for (var x = 4; x < splitedArray.length; x++) {
    ar[3] = ar[3] + splitedArray[x];
  }

  return ar;
};
var adsDiv = function adsDiv(adsId, indexonScreen, articleIndex) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: "container-row py-2 ads-auto-resize",
    align: "center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
      id: "ads",
      style: {
        fontSize: "11px !important",
        color: "#b7b7b7",
        textAlign: "center",
        marginBottom: "0px"
      },
      children: "Advertisement"
    }), indexonScreen === articleIndex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      id: adsId,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "text/javascript",
        dangerouslySetInnerHTML: {
          __html: "{googletag.cmd.push(function() { googletag.display('".concat(adsId, "')})")
        }
      })
    })]
  });
};
var removeEmbeds = function removeEmbeds(articleHtmlString) {
  var fs = "";
  var len = 7;
  var lenC = 9;

  for (var i = 0; i < articleHtmlString.length; i++) {
    var c = articleHtmlString.charAt(i);

    if (c === "<" && i + len <= articleHtmlString.length && articleHtmlString.substring(i, i + len) === "<script") {
      i = i + len;

      while (articleHtmlString.substring(i, i + lenC) !== "</script>") {
        i++;
      }

      i = i + lenC;
    } else {
      fs = fs + c;
    }
  }

  return fs;
};
function divideArrayIntoColumns(arr, n) {
  if (n <= 0) {
    throw new Error("Number of columns (n) must be greater than 0.");
  }

  var result = [];
  var numRows = Math.ceil(arr.length / n);

  for (var i = 0; i < n; i++) {
    var column = [];

    for (var j = 0; j < numRows; j++) {
      var index = j * n + i;

      if (index < arr.length) {
        column.push(arr[index]);
      }
    }

    result.push(column);
  }

  return result;
}
function removeHtmlTags(input) {
  // Use a regular expression to remove HTML tags
  return input === null || input === void 0 ? void 0 : input.replace(/<[^>]*>/g, "");
}

/***/ }),

/***/ 8969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getAdsBySize; }
/* harmony export */ });
/* harmony import */ var _actionTypes_ads_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76921);

var getAdsBySize = function getAdsBySize() {
  return {
    type: _actionTypes_ads_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_ADS_BY_SIZE_INIT */ .vj
  };
};

/***/ }),

/***/ 25609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DD": function() { return /* binding */ getLiveShowPost; },
/* harmony export */   "E7": function() { return /* binding */ getTrendingPosts; },
/* harmony export */   "Kw": function() { return /* binding */ storyView; },
/* harmony export */   "Rt": function() { return /* binding */ getRelatedNews; },
/* harmony export */   "fy": function() { return /* binding */ getStats; },
/* harmony export */   "l2": function() { return /* binding */ getLivePostBySocket; },
/* harmony export */   "mT": function() { return /* binding */ postLike; }
/* harmony export */ });
/* unused harmony exports getliveStreamData, allpostData, allFeaturedData, getVisualStoryDetailsById */
/* harmony import */ var redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50406);
 //live show post actions

var getLiveShowPost = function getLiveShowPost() {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LIVESHOWPOST_GET_INIT */ .Jy
  };
};
var getLivePostBySocket = function getLivePostBySocket(payload) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LIVEPOSTSOCKET_GET_INIT */ .p5,
    payload: payload
  };
}; // trending POSTS

var getTrendingPosts = function getTrendingPosts() {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_TRENDING_POST_INIT */ .HK
  };
}; // LIKE-UNLIKE ACTIONS

var postLike = function postLike(payload, postType, postDetails, recordPerPage) {
  //console.log("postdetail",postDetails)
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .POST_LIKE_INIT */ .Nx,
    payload: payload,
    postType: postType,
    postDetails: postDetails,
    recordPerPage: recordPerPage
  };
}; //GET STATISTICS

var getStats = function getStats(payload) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_STATISTICS_INIT */ .PH,
    payload: payload
  };
}; // live streaming actions

var getliveStreamData = function getliveStreamData(payload) {
  return {
    type: LIVE_STREAM_DATA_INIT,
    payload: payload
  };
}; // stories view Count actions

var storyView = function storyView(payload, postType) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .POST_VIEW_COUNT_INIT */ .V1,
    payload: payload,
    postType: postType
  };
}; // post by categoryType

var allpostData = function allpostData(payload) {
  return {
    type: GET_ALL_POST_INIT,
    payload: payload
  };
}; // post by featuredData

var allFeaturedData = function allFeaturedData(payload) {
  return {
    type: GET_ALL_FEATURED_POST_INIT,
    payload: payload
  };
}; // get visual story by id

var getVisualStoryDetailsById = function getVisualStoryDetailsById(payload) {
  //console.log("called");
  return {
    type: VISUALSTORY_GET_INIT,
    payload: payload
  };
}; // Related ACTIONS

var getRelatedNews = function getRelatedNews(payload) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_RELATED_ARTICLES_INIT */ .GX,
    payload: payload
  };
};

/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);